import { useQuery } from '@tanstack/react-query';
import { getAlertsSummary, getAlertsTrendComparison, listShadowServices } from './api';
import { alertsKey } from './key';
import type { AlertsSummaryQuery, ShadowServicesQuery } from './type';
export const useAlertsSummary = (params?: AlertsSummaryQuery) => {
  return useQuery({
    queryKey: alertsKey.summary(params),
    queryFn: () => getAlertsSummary(params),
    staleTime: 5 * 60 * 1000
  });
};
export const useAlertsTrendComparison = (params?: {
  year?: number;
  month?: number;
}) => {
  return useQuery({
    queryKey: alertsKey.trendComparison(params),
    queryFn: () => getAlertsTrendComparison(params),
    staleTime: 5 * 60 * 1000
  });
};
export const useShadowServices = (params: ShadowServicesQuery) => {
  return useQuery({
    queryKey: alertsKey.list(params),
    queryFn: () => listShadowServices(params),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  });
};